import { render, staticRenderFns } from "./InvoicesTableHead.vue?vue&type=template&id=28a6d10b&scoped=true"
import script from "./InvoicesTableHead.vue?vue&type=script&lang=js"
export * from "./InvoicesTableHead.vue?vue&type=script&lang=js"
import style0 from "./InvoicesTableHead.vue?vue&type=style&index=0&id=28a6d10b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6d10b",
  null
  
)

export default component.exports